import { ReactElement, memo } from 'react';
import Tooltip from '@mui/material/Tooltip';

import { useOrderPendingStateInfo } from '~hooks/index';

import { OrderPendingStateChipProps } from './types';
import { OrderPendingStateChipRoot } from './styles';

const OrderPendingStateChip = ({
  itemStateTypeId,
  collectItemStateTypeId,
  size = 'medium',
}: OrderPendingStateChipProps): ReactElement => {
  const { description, color, tooltipMessage } = useOrderPendingStateInfo({
    itemStateTypeId,
    collectItemStateTypeId,
  });

  return (
    <Tooltip title={tooltipMessage} arrow>
      <OrderPendingStateChipRoot
        variant="filled"
        label={description}
        color={color}
        size={size}
      />
    </Tooltip>
  );
};

export default memo(OrderPendingStateChip);
